import { render, staticRenderFns } from "./importBtn.vue?vue&type=template&id=2226b0d4&scoped=true&"
import script from "./importBtn.vue?vue&type=script&lang=js&"
export * from "./importBtn.vue?vue&type=script&lang=js&"
import style0 from "./importBtn.vue?vue&type=style&index=0&id=2226b0d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226b0d4",
  null
  
)

export default component.exports